<div class="row">
    <div class="container-fluid pl-0 pr-0">
        <div class="row">
            <div class="col-xl-12">
                <div class="card card-header-actions mx-auto">
                    <div class="card-header">
                        Employee Leave Report
                    </div>
                    <div class="card-body">
                        <form [formGroup]="empLeaveRptForm">
                            <div class="row">
                               <div class='col-xl-2 col-md-2'>
                                            <div class="form-group">
                                                <div class='date' id='datetimepicker6'>
                                                    <label class="control-label">From Date <span
                                                            class="text-danger">*</span> </label>
                                                    <div>
                                                        <input id="from_date" name="from_date" type="text"
                                                            autocomplete="off" onpaste="return false" placeholder="From"
                                                            bsDatepicker #dp="bsDatepicker" (focus)="dp.show()"
                                                            (focus)="dp1.hide()" formControlName="from_date"
                                                            [maxDate]="max_date" onkeypress='return event.charCode == 8'
                                                            [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false }"
                                                            [ngClass]="{ 'is-invalid': submitted && f.from_date.errors }"
                                                            class="form-control form-control-sm">
                                                        <div *ngIf="submitted && f.from_date.errors"
                                                            class="invalid-feedback">
                                                            <div *ngIf="f.from_date.errors.required">From Date is
                                                                required</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class='col-xl-2 col-md-2'>
                                            <div class="form-group">
                                                <div class='date' id='datetimepicker7'>
                                                    <label class="control-label">To Date <span
                                                            class="text-danger">*</span> </label>
                                                    <div>
                                                        <input id="to_date" name="to_date" type="text"
                                                            autocomplete="off" onpaste="return false" placeholder="To"
                                                            bsDatepicker formControlName="to_date"
                                                            [minDate]="f.from_date.value" [maxDate]="max_date"
                                                            (focus)="dp.hide()" bsDatepicker #dp1="bsDatepicker"
                                                            (focus)="dp1.show()"
                                                            [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false}"
                                                            [ngClass]="{ 'is-invalid': submitted && f.to_date.errors }"
                                                            class="form-control form-control-sm"
                                                            onkeypress='return event.charCode == 8'>
                                                        <div *ngIf="submitted && f.to_date.errors"
                                                            class="invalid-feedback">
                                                            <div *ngIf="f.to_date.errors.required">To Date is required
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                <div class="col-xl-3 col-md-3">
                            <label class="control-label">{{EnableHumanMMU?'MMU':'MVU'}} Name<span class="text-danger">*</span> </label>
                            <ng-multiselect-dropdown [settings]="dropdownSettings_MMU"
                                formControlName="mvu_id" [placeholder]="'All'"
                                (onSelectAll)="onAllItemSelectMMU($event)"
                                (onSelect)="onItemSelectMMU($event)"
                                (onDeSelectAll)="onAllItemDeSelectMMU($event)"
                                (onDeSelect)="onItemDeSelectMMU($event)" [data]="mvuLst"
                                [ngClass]="{ 'is-invalid': submitted && f['mvu_id'].errors }">
                            </ng-multiselect-dropdown>
                            <div *ngIf="submitted && f.mvu_id.errors" class="invalid-feedback">
                              <div *ngIf="f.mvu_id.errors.required">Please select {{EnableHumanMMU?'MMU':'MVU'}} Name
                              </div>
                          </div>
                            
                        </div>
                                <div class="col-xl-3 col-md-3">
                            <label class="control-label">Designation<span class="text-danger">*</span> </label>
                            <ng-multiselect-dropdown [settings]="dropdownSettings_des"
                                formControlName="designation" [placeholder]="'All'"
                                (onSelectAll)="onAllItemSelectDes($event)"
                                (onSelect)="onItemSelectDes($event)"
                                (onDeSelectAll)="onAllItemDeSelectDes($event)"
                                (onDeSelect)="onItemDeSelectDes($event)" [data]="dsgntnLst"
                                [ngClass]="{ 'is-invalid': submitted && f['designation'].errors }">
                            </ng-multiselect-dropdown>
                            <div *ngIf="submitted && f.designation.errors" class="invalid-feedback">
                              <div *ngIf="f.designation.errors.required">Please select designation
                              </div>
                          </div>
                            
                        </div>
                                <div class="col-xl-1 col-md-1 mt-4">
                                    <button type="submit" class="btn btn-sm btn-primary mt-2" value="Submit"
                                        (click)="loadData(0)">Submit</button>
                                </div>
                            </div>
                        </form>
                        <div class="row mt-4">
                                    <div class="col-xl-1">
                                         <button type="button" class="btnExcel" (click)="downLoadExcelKpi()"> <i
                                                class="fa fa-file-excel-o"></i>&nbsp;Excel</button> 
                                       
                                    </div>
                                    <div class="col-xl-8"></div>
                                    <div class="col-xl-3">
                                        <label>Search</label>
                                        <input type="text" [(ngModel)]="search_string" [ngModelOptions]="{standalone: true}"
                                            class="form-control form-control-sm" maxlength="50" ngMaxlength=50 value="{{search_string}}"
                                            (input)="loadData(0)">
                                    </div>
                                </div>

                                <div class="row mt-4 ml-1 mr-1">
                        <div class="table-responsive">
                            <table class="table table-striped table-bordered table-hover table-sm">
                                <thead style="font-size: small;">
                                    <tr style="white-space: nowrap;">
                                        <th>S No</th>
                                        <th>Employee Name</th>
                                        <th>Desgination</th>
                                        <th>Mobile</th>
                                        <th style="white-space: nowrap;">MMU Name</th>
                                        <th style="white-space: nowrap;">Leave Type</th>
                                        <th>Leave Taken From</th>
                                        <th>Leave Taken To</th>
                                        <th>Action</th>
                                        
                                    </tr>
                                </thead>
                                <tbody style="font-size: small;">
                                    <tr *ngFor="let item of lstGrid; let i = index">
                                        <td>{{ (rowIndex + 1 + i) }}</td>
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.user_type }}</td>
                                        <td style="white-space:normal;">{{ item?.mobile_no }}</td>
                                        <td>{{ item?.mvu_name }}</td>
                                        <td>{{ item?.leave_type }}</td>
                                        <td>{{ item.from_date | date:'dd-MM-yyyy' }}</td>
                                        <td>{{ item.to_date | date:'dd-MM-yyyy' }}</td>
                                        <td>
                                            <span *ngIf="item?.document"><a title="Document" style="cursor: pointer;"
                                                            (click)="viewDocument(item.document)"><i
                                                                class="text-primary fa fa-eye"></i>&nbsp;</a></span>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot *ngIf="lstGrid.length == 0">
                                    <tr>
                                        <td colspan="13" style="text-align: center;background-color: #F2F2F2;">No data available in table
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                    
                            <!-- Pagination & Info like KPI table -->
                            <div class="row">
                                <div class="col-sm-12 col-md-5">
                                    <div>
                                        Showing {{ (rowIndex+1) }} to {{ (rowIndex + lstGrid.length) }} of {{ totalElements }} entries.
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-7">
                                    <div>
                                        <nav aria-label="Page navigation example">
                                            <ul class="pagination justify-content-end">
                                                <li class="page-item" *ngIf="PrevpageNumber >= 0">
                                                    <a class="page-link" (click)="loadData(PrevpageNumber)" style="cursor:pointer">
                                                        <span>Previous</span>
                                                    </a>
                                                </li>
                                                <li class="page-item active" aria-current="page" *ngIf="NextpageNumber > 0">
                                                    <a class="page-link" (click)="loadData(NextpageNumber)" style="cursor:pointer">
                                                        <span>Next</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>